export const PLACEHOLDER_ORGANIZATION_ID = '00000000-0000-0000-0000-000000000000';
